import { useTranslation } from 'react-i18next';
import { Page } from '@web/components/page';
import { PetInsuranceScreen, PetInsuranceScreenProps } from 'shared/screens/pet-insurance';
import { usePartners } from 'shared/library/partners';
import { withServerProps } from '@web/library/with-server-props';

export default function PetInsurance(props: PetInsuranceScreenProps) {
  const { insurancePartner } = usePartners();
  const { t } = useTranslation('screens');

  return (
    <Page
      {...props}
      register={(seo) =>
        seo.setTitle(t('pet_insurance.title')).setDescription(
          t('pet_insurance.description', {
            partner: insurancePartner.name,
          }),
        )
      }
    >
      <PetInsuranceScreen {...props} />
    </Page>
  );
}

export const getServerSideProps = withServerProps();
